import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { authApi } from '../lib/api';

function getTokenKey(type) {
  return (type === 'admin' || type === 'admin_user') ? 'admin_auth_token' : 'hv_auth_token';
}

export function useAuth(requiredType = null) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const checkAuth = async () => {
      const tokenKey = requiredType ? getTokenKey(requiredType) : 'hv_auth_token';
      const token = localStorage.getItem(tokenKey);
      if (!token) {
        setLoading(false);
        if (requiredType) {
          navigate(requiredType === 'admin' ? '/admin/login' : '/app/login');
        }
        return;
      }

      try {
        const response = await authApi.getCurrentUser(token);
        const userData = response.data;

        if (requiredType && userData.user_type !== requiredType) {
          localStorage.removeItem(tokenKey);
          navigate(requiredType === 'admin' ? '/admin/login' : '/app/login');
          return;
        }

        setUser(userData);
      } catch (error) {
        console.error('Auth check failed:', error);
        localStorage.removeItem(tokenKey);
        if (requiredType) {
          navigate(requiredType === 'admin' ? '/admin/login' : '/app/login');
        }
      } finally {
        setLoading(false);
      }
    };

    checkAuth();
  }, [navigate, requiredType]);

  const logout = () => {
    const isAdmin = user?.user_type === 'admin_user';
    const tokenKey = isAdmin ? 'admin_auth_token' : 'hv_auth_token';
    localStorage.removeItem(tokenKey);
    localStorage.removeItem('user_data');
    setUser(null);
    navigate(isAdmin ? '/admin/login' : '/app/login');
  };

  return { user, loading, logout };
}

export { getTokenKey };

export default useAuth;
